module.exports = __webpack_public_path__ + "static/media/IVF_LM.b72f452a.png";